/**
 * File: AslVoiceRecordController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import * as RecordRTC from 'recordrtc';
class AslVoiceRecordController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state,Upload) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let aslVoiceRecord = this

    var recorder = {};

    $scope.isRecording = false;

    this.$onInit = function() {
      $scope.index = this.index
    };

    (function() {
      var params = {},
        r = /([^&=]+)=?([^&]*)/g;

      function d(s) {
        return decodeURIComponent(s.replace(/\+/g, ' '));
      }

      var match, search = window.location.search;
      while (match = r.exec(search.substring(1))) {
        params[d(match[1])] = d(match[2]);
        if (d(match[2]) === 'true' || d(match[2]) === 'false') {
          params[d(match[1])] = d(match[2]) === 'true' ? true : false;
        }
      }
      window.params = params;
    })();

    function addStreamStopListener(stream, callback) {
      var streamEndedEvent = 'ended';
      if ('oninactive' in stream) {
        streamEndedEvent = 'inactive';
      }
      stream.addEventListener(streamEndedEvent, function() {
        callback = function() {};
        callback();
      }, false);

      stream.getAudioTracks().forEach(function(track) {
        track.addEventListener(streamEndedEvent, function() {
          callback = function() {};
          callback();
        }, false);
      });

      stream.getVideoTracks().forEach(function(track) {
        track.addEventListener(streamEndedEvent, function() {
          callback = function() {};
          callback();
        }, false);
      });
    }

    //To capture media Stream
    function captureUserMedia(mediaConstraints, successCallback, errorCallback) {
      var isBlackBerry = !!(/BB10|BlackBerry/i.test(navigator.userAgent || ''));
      if (isBlackBerry && !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia)) {
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
        navigator.getUserMedia(mediaConstraints, successCallback, errorCallback);
        return;
      }
      navigator.mediaDevices.getUserMedia(mediaConstraints).then(successCallback).catch(errorCallback);
    }

    function intallFirefoxScreenCapturingExtension() {
      InstallTrigger.install({
        'Foo': {
          URL: 'https://addons.mozilla.org/firefox/downloads/file/355418/enable_screen_capturing_in_firefox-1.0.006-fx.xpi?src=cb-dl-hotness',
          toString: function() {
            return this.URL;
          }
        }
      });
    }

    $scope.startRecording = () => {
      var recordingElements = document.getElementsByClassName('asl-voice-record-class')
      captureUserMedia({
        audio: true
      }, function(audioStream) {
        recorder.stream = audioStream;
        recorder.recordRTC = new RecordRTC.StereoAudioRecorder(audioStream, {
          sampleRate: 44100,
          bufferSize: 4096
        });
        $scope.isRecording = true;
        addStreamStopListener(audioStream)
        recorder.recordRTC.record();
        _.each(recordingElements, function(element) {
          if (element.id != $scope.index) {
            element.disabled = true;
            $(element).addClass('asl-icon-div-disable')
          }
        })
        _.defer(function() { $scope.$apply(); });
      }, function(error) {
        if (error.name === 'PermissionDeniedError' && !!navigator.mozGetUserMedia) {
          intallFirefoxScreenCapturingExtension();
        }
      });
    }

    $scope.stopRecording = () => {
      user_id = Meteor.userId()
      recorder.recordRTC.stop(function(blob) {
        recorder.stream.stop()
        recorder.stream = null;
        Upload.upload({
          url: SERVER_UPLOAD,
          data: {
            file: blob,
            userPath: user_id + "/asl/"
          },
        }).then(function(response) {
          $scope.isRecording = false
          var recordingElements = document.getElementsByClassName('asl-voice-record-class')
          _.each(recordingElements, function(element) {
            element.disabled = false;
            $(element).removeClass('asl-icon-div-disable')
          })
          $scope.$parent.saveRecordedUrl(response.data, $scope.index)
        }, function(response) {}, function(evt) {});
      });
    }

    var isChrome = !!navigator.webkitGetUserMedia;
    var DetectRTC = {};

    (function() {

      var screenCallback;

      DetectRTC.screen = {
        chromeMediaSource: 'screen',
        getSourceId: function(callback) {
          if (!callback) throw '"callback" parameter is mandatory.';
          screenCallback = callback;
          window.postMessage('get-sourceId', '*');
        },
        isChromeExtensionAvailable: function(callback) {
          if (!callback) return;

          if (DetectRTC.screen.chromeMediaSource == 'desktop') return callback(true);

          // ask extension if it is available
          window.postMessage('are-you-there', '*');

          setTimeout(function() {
            if (DetectRTC.screen.chromeMediaSource == 'screen') {
              callback(false);
            } else callback(true);
          }, 2000);
        },
        onMessageCallback: function(data) {
          if (!(typeof data == 'string' || !!data.sourceId)) return;

          // "cancel" button is clicked
          if (data == 'PermissionDeniedError') {
            DetectRTC.screen.chromeMediaSource = 'PermissionDeniedError';
            if (screenCallback) return screenCallback('PermissionDeniedError');
            else throw new Error('PermissionDeniedError');
          }

          // extension notified his presence
          if (data == 'rtcmulticonnection-extension-loaded') {
            if (document.getElementById('install-button')) {
              document.getElementById('install-button').parentNode.innerHTML = '<strong>Great!</strong> <a href="https://chrome.google.com/webstore/detail/screen-capturing/ajhifddimkapgcifgcodmmfdlknahffk" target="_blank">Google chrome extension</a> is installed.';
            }
            DetectRTC.screen.chromeMediaSource = 'desktop';
          }

          // extension shared temp sourceId
          if (data.sourceId) {
            DetectRTC.screen.sourceId = data.sourceId;
            if (screenCallback) screenCallback(DetectRTC.screen.sourceId);
          }
        },
        getChromeExtensionStatus: function(callback) {
          if (!!navigator.mozGetUserMedia) return callback('not-chrome');

          var extensionid = 'ajhifddimkapgcifgcodmmfdlknahffk';


        }
      };

      // check if desktop-capture extension installed.
      if (window.postMessage && isChrome) {
        DetectRTC.screen.isChromeExtensionAvailable();
      }
    })();

    DetectRTC.screen.getChromeExtensionStatus(function(status) {
      if (status == 'installed-enabled') {
        if (document.getElementById('install-button')) {
          document.getElementById('install-button').parentNode.innerHTML = '<strong>Great!</strong> <a href="https://chrome.google.com/webstore/detail/screen-capturing/ajhifddimkapgcifgcodmmfdlknahffk" target="_blank">Google chrome extension</a> is installed.';
        }
        DetectRTC.screen.chromeMediaSource = 'desktop';
      }
    });

    window.addEventListener('message', function(event) {
      if (event.origin != window.location.origin) {
        return;
      }

      DetectRTC.screen.onMessageCallback(event.data);
    });
        //On destroy function
        this.$onDestroy = () => {
        }

    }
}

export default AslVoiceRecordController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslVoiceRecordController.js